export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    type: 'checkbox',
    width: 50,
    align: 'center',
    fixed: 'left',
    visible: !that.disabled,
  },
  {
    field: 'col-opt',
    title: that.$l('table_label_operation') || '操作',
    align: 'center',
    width: 80,
    visible: !that.disabled,
    slots: { default: 'opt' },
  },
  {
    title: that.$l('label_startDate') || '开始日期',
    field: 'startDate',
    align: 'center',
    width: 170,
    showHeaderOverflow: true,
    showOverflow: true,
    editRender: {
      name: 'ElDatePicker',
      props: {
        placeholder: that.$l('tips_select_startDate') || '请选择开始日期',
        type: 'date',
        'value-format': 'yyyy-MM-dd',
        style: 'width: 100%',
        size: 'mini',
      },
    },
  },
  {
    title: that.$l('label_endDate') || '结束日期',
    field: 'endDate',
    align: 'center',
    width: 170,
    showHeaderOverflow: true,
    showOverflow: true,
    editRender: {
      name: 'ElDatePicker',
      props: {
        placeholder: that.$l('tips_select_endDate') || '选择日期',
        type: 'date',
        'value-format': 'yyyy-MM-dd',
        style: 'width: 100%',
        size: 'mini',
      },
    },
  },
  {
    title: that.$l('table_label_expenseName') || '费用项目',
    field: 'expenseName',
    align: 'center',
    width: 200,
    editRender: { enabled: true },
    slots: { edit: 'expense' },
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_financeExpense') || '财务费用',
    field: 'v_expenseType',
    align: 'center',
    width: 200,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_originalExpenseType') || '原始费用项目',
    field: 'v_originalExpenseType',
    align: 'center',
    width: 200,
    editRender: { enable: true },
    slots: { edit: 'originalExpenseType' },
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('form_label_billCount') || '单据张数',
    field: 'billCount',
    align: 'center',
    width: 130,
    showHeaderOverflow: true,
    showOverflow: true,
    editRender: {
      name: 'ElInputNumber',
      props: {
        precision: 0,
        min: 0,
        max: 1000000000,
        step: 1,
        'controls-position': 'right',
      },
    },
  },
  {
    title: that.$l('item_label_currencyAmount') || '费用金额',
    field: 'currencyAmount',
    align: 'center',
    width: 180,
    showHeaderOverflow: true,
    showOverflow: true,
    editRender: {
      name: 'ElInputNumber',
      props: {
        precision: 2,
        min: 0,
        max: 1000000000,
        step: 0.01,
        'controls-position': 'right',
      },
    },
  },
  {
    title: that.$l('item_label_custCode') || '费用客户',
    field: 'custName',
    headerAlign: 'center',
    align: 'left',
    minWidth: 250,
    editRender: { enable: true },
    slots: { edit: 'customer' },
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('item_label_custOrderNo') || '订单编号',
    field: 'custOrderNo',
    headerAlign: 'center',
    align: 'left',
    minWidth: 250,
    editRender: { enable: true },
    slots: { edit: 'custOrderNo' },
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_brand') || '品牌',
    field: 'brandCode',
    headerAlign: 'center',
    align: 'left',
    minWidth: 200,
    editRender: {
      name: 'dict-select',
      props: {
        url: '/master/common/dict/brandSelect',
        filterable: true,
        clearable: true,
        size: 'mini',
        placeholder: that.$l('table_label_please_select_brand') || '请选择品牌',
      },
    },
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_scm_name') || '供应商',
    field: 'scmCode',
    headerAlign: 'center',
    align: 'left',
    minWidth: 200,
    showHeaderOverflow: true,
    showOverflow: true,
    editRender: {
      name: 'dict-select',
      props: {
        url: '/master/common/dict/allScmCooperated',
        placeholder: that.$l('tips_select_scmCode') || '请选择...',
        filterable: true,
        clearable: true,
        size: 'mini',
      },
    },
  },
  {
    title: that.$l('item_label_orgDepFullName') || '分摊部门',
    field: 'orgDepFullName',
    headerAlign: 'center',
    align: 'left',
    minWidth: 300,
    editRender: { enable: true },
    slots: { edit: 'depedit', default: 'depview' },
    showHeaderOverflow: true,
    showOverflow: true,
  },
]
